angular.module('vastdesk').component('forecastBudgetFields', {
  bindings: {
    formName: '@',
    formId: '@',
    budget: '=',
    onRemoveBudget: '&',
  },
  template: require('../templates/forecastBudgetFields.html'),
  controllerAs: '$forecastBudgetFieldsCtrl',
  controller: [function () {
    const self = this;

    this.availableMetrics = [
        ['revenue', 'Revenue'],
        ['requests', 'Requests'],
        ['impressions', 'Imps'],
    ];
    this.availablePeriods = [
        ['day', 'Day'],
        ['week', 'Week'],
        ['month', 'Month'],
        ['lifetime', 'Life'],
    ];
    this.availablePacing = [
        ['smooth', 'Even'],
        ['front_loaded', 'Front-Loaded'],
    ];

    this.hasId = function () {
      return typeof self.budget.id !== "undefined" && self.budget.id !== null;
    };

    this.removeBudget = function () {
      if (self.onRemoveBudget) {
        self.onRemoveBudget();
      }
    };
  }]
});
